module.exports = __webpack_public_path__ + "media/01.94deaa46.mp3";